
import { ReactComponent as PrivacyChoicesGlyph } from '@/assets/images/svg/glyphs/privacy-choices.svg';
import Link from '@/components/_rebrand/Link';
import cn from 'classnames';
import { FooterBackgroundColor } from './Footer.types';

type LegalLinksSectionProps = {
  backgroundColor: FooterBackgroundColor;
  copyright: string;
  legalLinks: {
    title: string;
    href: string;
  }[];
}

export const LegalLinksSection = ({ backgroundColor, copyright, legalLinks }: LegalLinksSectionProps) => {
  return (
    <div
      className={cn('border-t border-solid pt-4 text-12/16', {
        'border-violet-500': backgroundColor === 'violet',
      })}
    >
      <div className="grid grid-cols-12 gap-y-4 gap-gutter-mobile md:gap-x-gutter-desktop">
        <div className="col-span-12 xl:col-span-4">
          <p
            className={cn({
              'text-violet-300': backgroundColor === 'violet',
            })}
          >
            {copyright}
          </p>
        </div>
        <div className="col-span-12 xl:col-span-8">
          <ul className="flex flex-col gap-2 xl:flex-row xl:gap-1 xl:justify-between">
            {legalLinks.map((link) => (
              <li key={`footer-legal-link-${link.href}`}>
                <Link
                  href={link.href}
                  className={cn('hover:text-white duration-200 transition-colors ease-in-quad', {
                    'text-violet-300': backgroundColor === 'violet',
                  })}
                >
                  {link.title}
                </Link>
              </li>
            ))}
            <li>
              <span
                onClick={() => {
                  window.OneTrust.ToggleInfoDisplay();
                }}
                className={cn('cursor-default hover:text-white duration-200 transition-colors ease-in-quad', {
                  'text-violet-300': backgroundColor === 'violet',
                })}
              >Your Privacy Choices <PrivacyChoicesGlyph width={28} style={{ display: 'inline-block' }} />
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  )
}
